export default __webpack_public_path__ + "static/media/11-46.a5d8d19a.png";